import { registerPlugin } from '../registry';
import type { PluginManifest, PluginContext } from '../types';
import ChiroToolPicker from './components/ChiroToolPicker';
import ChiroWizard from './components/ChiroWizard';

function ChiroIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {/* spine glyph */}
      <path d="M12 2 v20" />
      <path d="M8 5 h8" />
      <path d="M7 9 h10" />
      <path d="M8 13 h8" />
      <path d="M9 17 h6" />
      <path d="M10 21 h4" />
    </svg>
  );
}

function openPicker(ctx: PluginContext) {
  const closeAll = () => ctx.hideModal();
  const onSelectTool = (toolId: number) => {
    ctx.showModal(<ChiroWizard toolId={toolId} ctx={ctx} onClose={closeAll} />);
  };
  ctx.showModal(
    <ChiroToolPicker
      onSelectTool={onSelectTool}
      onClose={closeAll}
      studyContext={ctx.getStudyContext()}
    />,
  );
}

const manifest: PluginManifest = {
  id: 'chiroTools',
  name: 'Chiropractic Measurement Tools',
  version: '1.0.0',
  toolbarButtons: [
    {
      id: 'chiro-picker',
      label: 'Chiro',
      icon: <ChiroIcon />,
      section: 'measurement',
      onClick: openPicker,
    },
  ],
};

registerPlugin(manifest);
